import {Api} from "@/common/api/Api";
import {AxiosInstance, AxiosResponse} from "axios";
import SensorTagRouter from "@/context/sensor/router/SensorTagRouter";
import AutocompleteApi from "@/common/api/AutocompleteApi";
import {SensorTagAutocompleteModel} from "@/context/sensor/model/SensorTagAutocompleteModel";
import {axiosInstance} from "@/plugins/axios";

export class SensorTagApi extends Api {
  constructor(axios: AxiosInstance) {
    super(SensorTagRouter.BASE_PATH, axios);
  }

  private static _instance: SensorTagApi;
  public static instance(): SensorTagApi {
    if (!SensorTagApi._instance) {
      SensorTagApi._instance = new SensorTagApi(axiosInstance);
    }
  return SensorTagApi._instance;
}

  public static async findAutocomplete(
    search: string,
    query: string
  ): Promise<Array<SensorTagAutocompleteModel>> {
    const response: AxiosResponse = await AutocompleteApi.findAutocomplete(
      SensorTagRouter.BASE_PATH,
      search,
      query
    );
    return response.data;
  }

}
